// Subtle global background decoration: an ethereal constellation skull
// (memento-mori / impermanence motif) blended over the dark theme on every page.
export const SkullDecor = () => (
  <div aria-hidden="true" data-testid="skull-decor" className="pointer-events-none fixed inset-0 z-0 flex items-center justify-center overflow-hidden">
    <img
      src="/decor/skull.jpg?v=2"
      alt=""
      draggable="false"
      className="w-[72vmin] max-w-none select-none mix-blend-screen opacity-[0.13]"
      style={{ filter: "blur(0.4px)" }}
    />
  </div>
);
